import React from 'react';
import { Accordion, Card, Alert, Spinner, Table, } from 'react-bootstrap';
import {
  reduxForm,
} from 'redux-form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { withRouter } from 'react-router';
import { Show } from 'Layout';
import { PageStatus } from 'enums';
import { SamplesAPI } from "../../API";
import { ProfileManagementAPI } from "../../API/ProfileManagementAPI";
import Select from 'react-select';
import moment from "moment";

export type FormValue = {
  name: string,
};


type State = {
  status: string,
  error: string | null,
  data: any,
  name: string,
};

function removeDuplicates(arr, property) {
  const uniqueMap = {};
  return arr.filter(obj => {
    if (obj[property]) {
      const value = obj[property];
      if (!uniqueMap[value]) {
        uniqueMap[value] = true;
        return true;
      }
      return false;
    }
  });
}

class Form extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      status: PageStatus.None,
      isLoading: true,
      error: null,
      data: '',
      name: "",
      description: "",
      "gender": '',
      "isActive": true,
      "profileCount": 0,
      "fromAge": null,
      "toAge": null,
      "fromRegistrationDate": null,
      "toRegistrationDate": null,
      "stateIds": [],
      "cityIds": [],
      "tierIds": [],
      segmentsIds: [],
      regionsIds: [],
      states: [],
      cities: [],
      tiers: [],
      segments: [],
      regions: [],
      selectedStatesOption: [],
      selectedCitiesOption: [],
      selectedTiersOption: [],
      selectedSegmentsOption: [],
      selectedRegionsOption: [],
      genderOptions: [{ label: "Male", value: 'Male' }, { label: "Female", value: 'Female' }, { label: "Other", value: 'Other' }],
      dynamicFields: [{
        gender: [],
        fromAge: null,
        toAge: null
      }],
      selectedRegionValues: [],//chng
      selectedTiers: [],//chng
      selectedStates: [],//chng
      selectedSegments: [],//chng
      selectedCities: [],//chng
      selectedGenders: [],//chng
      accordience: [],
      profileAnswers: [],
      selectedProfileId: null,
      selectedQuestionId: null,
      isCheckboxDisabled: false, // State to track if checkboxes should be disabled
      profileQuestion: [],
      profileTarget: [],
      questionTarget: [], // Initialize as an empty array
      answersTarget: [], // Initialize as an empty array
      disabledCheckboxes: {}, // Initialize disabledCheckboxes as an empty object
      updatecheckedProfileTarget: false,
      updatecheckedQuestions: false,
      updatecheckedAnswers: false,
      selectedTableItemsArray: [],
      minToRegistrationDate: "",
      maxFromRegistrationDate: "",
      enableDisableTargetPanelistButton: { "status": false, "text": "Update Targeted Panelists" },
      loginType: {
        "desktop": false,
        "tablet": false,
        "mobile": false,
        "windows": false,
        "mac": false,
        "tablet_android": false,
        "tablet_ios": false,
        "mobile_android": false,
        "mobile_ios": false,
      },
    };
  }

  componentDidMount() {
    if (this.props.id) {
      this.fetchDetails();
    } else {
      this.fetchList().then(() => this.targetpanelist());
    }
  }

  fetchDetails() {
    Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => {
        if (!this.props.id) {
          return Promise.reject(new Error('Invalid ID'));
        }

        return SamplesAPI.getOne(this.props.id);
      })
      .then((data: any) => {
        this.initializeValues(data.sample);
        this.setState({
          data: data.sample,
          status: PageStatus.Loaded,
        }, () => {
          this.fetchList()
        });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  fetchList(): Promise<void> {
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Loading }))
      .then(() => {
        this.Total_no_panelist()
        this.Accordion_databview()
        this.setState({ status: PageStatus.Loaded })
      })
      .catch((error) => {
        this.setState({ error: error.message, status: PageStatus.Error });
      });
  }

  formValues() {
    return {
      name: this.state.name,
      description: this.state.description,
      // "gender": this.state.gender,
      "isActive": this.state.isActive,
      "profileCount": this.state.profileCount,
      "fromAge": this.state.fromAge,
      "toAge": this.state.toAge,
      "fromRegistrationDate": this.state.fromRegistrationDate,
      "toRegistrationDate": this.state.toRegistrationDate,
      "stateIds": this.state.stateIds,
      "cityIds": this.state.cityIds,
      "tierIds": this.state.tierIds,
      "segments": this.state.segmentsIds,
      "regions": this.state.regionsIds,
      "genders": this.state.dynamicFields,
      "profileTarget": this.state.profileTarget,
      "questionTarget": this.state.questionTarget,
      "answersTarget": this.state.answersTarget,
      "loginType": this.state.loginType,
    };
  }

  initializeValues(data) {
    return this.setState({
      name: data.name,
      description: data.description,
      // "gender": data.gender,
      "isActive": data.isActive,
      "profileCount": data.profileCount,
      "fromAge": data.fromAge,
      "toAge": data.toAge,
      fromRegistrationDate: data.fromRegistrationDate ? moment(data.fromRegistrationDate).format("YYYY-MM-DD") : null,
      toRegistrationDate: data.toRegistrationDate ? moment(data.toRegistrationDate).format("YYYY-MM-DD") : null,
      "stateIds": data.stateIds,
      "cityIds": data.cityIds,
      "tierIds": data.tierIds,
      "selectedStates": data.stateIds.map(ele => ele.value),
      "selectedCities": data.cityIds.map(ele => ele.value),
      "selectedTiers": data.tierIds.map(ele => ele.value),
      "selectedSegments": data.segments.map(ele => ele.value),
      "selectedRegionValues": data.regions.map(ele => ele.value),
      selectedStatesOption: data.stateIds,
      selectedCitiesOption: data.cityIds,
      selectedTiersOption: data.tierIds,
      "segmentsIds": data.segments,
      "regionsIds": data.regions,
      selectedSegmentsOption: data.segments,
      selectedRegionsOption: data.regions,
      "dynamicFields": data.genders,
      // "profileTarget": data.profileTarget,
      "questionTarget": data.questionTarget,
      "answersTarget": data.answersTarget,
      loginType: {
        "desktop": data.desktopWindows == "Y" || data.desktopMac == "Y",
        "tablet": data.tabAndroid == "Y" || data.tabIos == "Y",
        "mobile": data.mobileAndroid == "Y" || data.mobileIos == "Y",
        "windows": data.desktopWindows == "Y",
        "mac": data.desktopMac == "Y",
        "tablet_android": data.tabAndroid == "Y",
        "tablet_ios": data.tabIos == "Y",
        "mobile_android": data.mobileAndroid == "Y",
        "mobile_ios": data.mobileIos == "Y",
      },

    }, () => {
      this.handleUpdateTableData();
      this.targetpanelist();
    });
  }

  handleUpdateTableData() {
    let newArr1 = this.state.profileTarget;
    let newArr2 = this.state.questionTarget;
    let newArr3 = this.state.answersTarget;
    let newFinalArr: any = [];
    if (newArr1) {
      newArr1.forEach((elem) => {
        return Promise.resolve()
          .then(() => this.setState({ status: PageStatus.Loading }))
          .then(() => ProfileManagementAPI.getOne(elem))
          .then((data) => {
            newFinalArr.push({ "profileName": data.name, "id": data.id, type: "Profile" });
            return this.setState({ status: PageStatus.Loaded });
          })
          .catch((error) => {
            this.setState({ status: PageStatus.Error, error: error.message });
          });
      })
    }
    if (newArr2) {
      newArr2.forEach((elem) => {
        return Promise.resolve()
          .then(() => this.setState({ status: PageStatus.Loading }))
          .then(() => ProfileManagementAPI.getOneQuestions(elem))
          .then(async (data) => {
            const profileDetailsvar = await ProfileManagementAPI.getOne(data.dataValues.profileId);
            newFinalArr.push({ "profileName": profileDetailsvar.name, "questionName": data.dataValues.text, "id": data.dataValues.id, "questionId": data.dataValues.id, "profileId": data.dataValues.profileId, "type": "Question" });
            return this.setState({ status: PageStatus.Loaded });
          })
          .catch((error) => {
            this.setState({ status: PageStatus.Error, error: error.message });
          });
      })
    }
    if (newArr3) {
      newArr3.forEach((elem) => {
        return Promise.resolve()
          .then(() => this.setState({ status: PageStatus.Loading }))
          .then(() => ProfileManagementAPI.getOptionDetails(elem))
          .then(async (data) => {
            const profileDetailsvar = await ProfileManagementAPI.getOne(data[0].profileId);
            const questionDetailsvar = await ProfileManagementAPI.getOneQuestions(data[0].questionId);
            newFinalArr.push({ "profileName": profileDetailsvar.name, "questionName": questionDetailsvar.dataValues.text, "answerName": data[0].value, "id": data[0].id, "questionId": data[0].questionId, "profileId": data[0].profileId, "type": "Answer" });
            return this.setState({ status: PageStatus.Loaded });
          })
          .catch((error) => {
            this.setState({ status: PageStatus.Error, error: error.message });
          });
      })
    }
    this.setState({ selectedTableItemsArray: newFinalArr, enableDisableTargetPanelistButton: { "status": true, "text": "Updated" } });
  }

  onSubmit() {
    let { enableDisableTargetPanelistButton, selectedTableItemsArray } = this.state;
    if ((!enableDisableTargetPanelistButton.status) && (selectedTableItemsArray.length > 0)) {
      alert("You have selected the additional profile targeting but not updated the targeted panelist count.");
      return;
    }
    if (!this.props.id) {
      return this.create();
    }
    return this.update();
  }

  create() {
    const valuesIn = this.formValues();
    const doCreate = this.props.onCreateOverride
      ? () => this.props.onCreateOverride(valuesIn)
      : () => SamplesAPI.create(valuesIn);
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(doCreate)
      .then((data) => {
        this.props.onSubmit(data.id, "normal");
        return this.setState({ status: PageStatus.Submitted });
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  update() {
    const valuesIn = this.formValues()
    return Promise.resolve()
      .then(() => this.setState({ status: PageStatus.Submitting }))
      .then(() => SamplesAPI.update(this.props.id, valuesIn))
      .then(() => {
        this.setState({ status: PageStatus.Submitted });
        return this.props.onSubmit(this.props.id, "normal");
      })
      .catch((error) => {
        this.setState({ status: PageStatus.Error, error: error.message });
      });
  }

  reset() {
    return this.setState({
      name: "",
      description: "",
      "gender": '',
      "isActive": true,
      "profileCount": 0,
      "fromAge": null,
      "toAge": null,
      "fromRegistrationDate": null,
      "toRegistrationDate": null,
      "stateIds": [],
      "cityIds": [],
      "tierIds": [],
      segmentsIds: [],
      regionsIds: [],
      selectedRegionValues: [],
      selectedTiers: [],
      selectedStates: [],
      selectedSegments: [],
      selectedCities: [],
      selectedGenders: [],
      selectedStatesOption: [],
      selectedCitiesOption: [],
      selectedTiersOption: [],
      selectedSegmentsOption: [],
      selectedRegionsOption: [],
      genderOptions: [{ label: "Male", value: 'Male' }, { label: "Female", value: 'Female' }, { label: "Other", value: 'Other' }],
      dynamicFields: [{
        gender: [],
        fromAge: null,
        toAge: null
      }],
      selectedTableItemsArray: [],
      profileQuestion: [],
      profileTarget: [],
      questionTarget: [],
      answersTarget: [],
      disabledCheckboxes: {},
      enableDisableTargetPanelistButton: { "status": false, "text": "Update Targeted Panelists" },
      loginType: {
        "desktop": false,
        "tablet": false,
        "mobile": false,
        "windows": false,
        "mac": false,
        "tablet_android": false,
        "tablet_ios": false,
        "mobile_android": false,
        "mobile_ios": false,
      },
    }, () => { this.updatePayload(); });
  }

  handleRegistrationDateChange = (e, tp) => {
    this.setState((prev) => {
      if (tp == "from") {
        return { fromRegistrationDate: e.target.value == "" ? null : e.target.value, minToRegistrationDate: e.target.value }
      } else {
        return { toRegistrationDate: e.target.value == "" ? null : e.target.value, maxFromRegistrationDate: e.target.value }
      }
    })
  }

  targetPanelistOnRgistrationDate = () => {
    if ((this.state.toRegistrationDate && this.state.fromRegistrationDate) ||
      (this.state.toRegistrationDate == "" || this.state.fromRegistrationDate == "") ||
      (this.state.toRegistrationDate == null || this.state.fromRegistrationDate == null)
    ) { this.updatePayload(); }
  }

  handleRegionChange = async (selectedRegionsOption) => {
    this.setState({ regionsIds: selectedRegionsOption, selectedRegionsOption, selectedTiersOption: [], selectedStatesOption: [], selectedSegmentsOption: [], selectedCitiesOption: [], selectedTiers: [], selectedStates: [], selectedSegments: [], selectedCities: [], });
    const selectedRegionValues = selectedRegionsOption.map(option => option.value);
    this.setState(prevState => {
      const prevValues = new Set(prevState.selectedRegionValues);
      selectedRegionValues.forEach(value => prevValues.add(value));
      prevState.selectedRegionValues.forEach(value => {
        if (!selectedRegionValues.includes(value)) {
          prevValues.delete(value);
        }
      });
      const updatedSelectedRegionValues = Array.from(prevValues);

      return {
        regionsIds: selectedRegionsOption,
        selectedRegionsOption,
        selectedRegionValues: updatedSelectedRegionValues
      };
    }, () => {
      this.updatePayload();
    });
  };

  handleTierChange = async (selectedTiersOption) => {
    this.setState({ tierIds: selectedTiersOption, selectedTiersOption, selectedStatesOption: [], selectedSegmentsOption: [], selectedCitiesOption: [], selectedStates: [], selectedSegments: [], selectedCities: [], });
    const selectedTierValues = selectedTiersOption.map(option => option.value);
    this.setState(prevState => {
      const prevValues = new Set(prevState.selectedTiers);
      selectedTierValues.forEach(value => prevValues.add(value));
      prevState.selectedTiers.forEach(value => {
        if (!selectedTierValues.includes(value)) {
          prevValues.delete(value);
        }
      });
      const updatedSelectedTiers = Array.from(prevValues);

      return {
        tierIds: selectedTiersOption,
        selectedTiersOption,
        selectedTiers: updatedSelectedTiers
      };
    }, () => {
      this.updatePayload();
    });
    // ----------------------------------
  };

  handleStateChange = async (selectedStatesOption) => {
    this.setState({ stateIds: selectedStatesOption, selectedStatesOption, selectedSegmentsOption: [], selectedCitiesOption: [], selectedSegments: [], selectedCities: [], });
    const selectedStateValues = selectedStatesOption.map(option => option.value);
    this.setState(prevState => {
      const prevValues = new Set(prevState.selectedStates);
      selectedStateValues.forEach(value => prevValues.add(value));
      prevState.selectedStates.forEach(value => {
        if (!selectedStateValues.includes(value)) {
          prevValues.delete(value);
        }
      });
      const updatedSelectedStates = Array.from(prevValues);
      return {
        stateIds: selectedStatesOption,
        selectedStatesOption,
        selectedStates: updatedSelectedStates
      };
    }, () => {
      this.updatePayload();
    });
    // -----------------------------------------------
  };

  handleSegmentChange = async (selectedSegmentsOption) => {
    this.setState({ segmentsIds: selectedSegmentsOption, selectedSegmentsOption, selectedCitiesOption: [], selectedCities: [], });
    const selectedSegmentValues = selectedSegmentsOption.map(option => option.value);
    this.setState(prevState => {
      const prevValues = new Set(prevState.selectedSegments);
      selectedSegmentValues.forEach(value => prevValues.add(value));
      prevState.selectedSegments.forEach(value => {
        if (!selectedSegmentValues.includes(value)) {
          prevValues.delete(value);
        }
      });
      const updatedSelectedSegments = Array.from(prevValues);
      return {
        segmentsIds: selectedSegmentsOption,
        selectedSegmentsOption,
        selectedSegments: updatedSelectedSegments
      };
    }, () => {
      this.updatePayload();
    });
  };

  handleCityChange = async (selectedCitiesOption) => {
    this.setState({ cityIds: selectedCitiesOption, selectedCitiesOption });
    // ---------add change-------------------------
    const selectedCityValues = selectedCitiesOption.map(option => option.value);
    this.setState(prevState => {
      const prevValues = new Set(prevState.selectedCities);
      selectedCityValues.forEach(value => prevValues.add(value));
      prevState.selectedCities.forEach(value => {
        if (!selectedCityValues.includes(value)) {
          prevValues.delete(value);
        }
      });
      const updatedSelectedCities = Array.from(prevValues);

      return {
        cityIds: selectedCitiesOption,
        selectedCitiesOption,
        selectedCities: updatedSelectedCities
      };
    }, () => {
      this.updatePayload();
    });
  };


  handleAgeFilterValue = (e, index, field) => {
    const { dynamicFields } = this.state;
    const updatedFields = [...dynamicFields];
    updatedFields[index][field] = e;
    this.setState({ dynamicFields: updatedFields });
  }

  handleUpdatedGender = (currentGenders, selectedGender, updatedGenderField) => {
    return currentGenders.filter(gender =>
      selectedGender.includes(gender) || updatedGenderField.some(option => option.value === gender)
    ).concat(
      updatedGenderField.map(option => option.value).filter(gender => !currentGenders.includes(gender))
    );
  }
  handleDynamicFieldChange = (e, index, field) => {
    const { dynamicFields } = this.state;
    const updatedFields = [...dynamicFields];
    updatedFields[index][field] = e;

    this.setState({ dynamicFields: updatedFields }, () => {
      let selectedGender: string[] = [];
      if (field === 'gender') {
        if (Array.isArray(e)) {
          selectedGender = e.map(option => option.value);
        } else {
          selectedGender = e.value ? [e.value] : [];
        }
      }

      this.setState(prevState => {
        let newSelectedGenders;
        if (field === 'gender') {
          const currentGenders = prevState.selectedGenders;
          const updatedGenderField = updatedFields[index][field];

          if (Array.isArray(updatedGenderField)) {
            //Hey! sonarqube, please ignore this code
            // newSelectedGenders = currentGenders.filter(gender =>
            //   selectedGender.includes(gender) || updatedGenderField.some(option => option.value === gender)
            // ).concat(
            //   updatedGenderField.map(option => option.value).filter(gender => !currentGenders.includes(gender))
            // );
            newSelectedGenders = this.handleUpdatedGender(currentGenders, selectedGender, updatedGenderField);
          } else if (updatedGenderField.value) {
            newSelectedGenders = [...currentGenders, updatedGenderField.value];
          } else {
            const removedGender = prevState.dynamicFields[index].gender.value;
            newSelectedGenders = currentGenders.filter(gender => gender !== removedGender);
          }
        } else {
          newSelectedGenders = prevState.selectedGenders;
        }
        return { selectedGenders: newSelectedGenders };
      }, () => {
        this.updatePayload();
        // Hey! sonarqube, Please ignore this code
        // if (field === 'gender') {
        //   this.updatePayload();
        // } else if (updatedFields[index].toAge && updatedFields[index].fromAge) {
        //   this.updatePayload();
        // }
      });
    });
  };

  // ==============Add functionallity===================
  updatePayload = () => {
    this.targetpanelist();
  };
  targetPanelistRequestId: number = 0;
  targetpanelist = async () => {
    this.targetPanelistRequestId = (this.targetPanelistRequestId || 0) + 1;
    const currentRequestId = this.targetPanelistRequestId;
    const {
      // selectedGenders = [],
      dynamicFields = [],
      selectedRegionValues = [],
      selectedTiers = [],
      selectedStates = [],
      selectedSegments = [],
      selectedCities = [],
      profileTarget = [],  // Consistent variable name
      questionTarget,  // This should now be updated with checked IDs
      answersTarget,  // This should now be updated with checked IDs
      toRegistrationDate,
      fromRegistrationDate,
      loginType,
      isActive,
    } = this.state;
    const requestBody = {
      ...(dynamicFields.length > 0 && {
        ...({ genders: dynamicFields.filter((ele) => ele.gender != "" || (ele.fromAge != null && ele.toAge != null)) })
      }),
      ...(selectedRegionValues.length > 0 && { regions: selectedRegionValues }),
      ...(selectedTiers.length > 0 && { tier: selectedTiers }),
      ...(selectedStates.length > 0 && { state: selectedStates }),
      ...(selectedSegments.length > 0 && { segment: selectedSegments }),
      ...(selectedCities.length > 0 && { city: selectedCities }),
      ...(profileTarget.length > 0 && { profileTarget: profileTarget }), // Add profileTarget conditionally
      ...(questionTarget.length > 0 && { questionTarget: questionTarget }), // Include checked IDs
      ...(answersTarget.length > 0 && { answersTarget: answersTarget }), // Fixed key name
      ...({ toRegistrationDate, fromRegistrationDate }),
      ...({ loginType }),
      // ALWAYS sent — never wrap this in a conditional spread. The fields above
      // use `...(x.length > 0 && { x })` because omitting an empty array is
      // meaningful for them. isActive is a BOOLEAN where `false` is a real
      // value: conditionally spreading it would omit the key whenever the
      // Active checkbox is unticked, the server's `!!isActive` would read
      // undefined, and "show me inactive panelists too" would silently behave
      // as "filter to active only" — the same truthy/falsy class of bug as
      // DEFECT-6. The server destructures this from req.body top level
      // (Samples.controllers.js:3199) and feeds it to activeOnly.
      isActive,
    };
    const overrideCountry = this.props.lockedCountry?.value;
    // Item #3 fix: this is a per-field-blur count PREVIEW recompute. It must NOT
    // flip the page-level status to Loading/Loaded — the form body only renders
    // when status===Loaded (see render ~L1029), so toggling status unmounts and
    // remounts the ENTIRE form on every blur (the "full screen refresh" testers
    // saw, with lost focus/scroll). The counts are written via direct DOM below,
    // which needs no form re-render. We keep the form mounted throughout and only
    // update the count widgets when the API responds. A transient count-preview
    // error is logged (not raised to PageStatus.Error, which would also blank
    // the form); the real save path keeps its own validation/error handling.
    const loaderHtml = '<span class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>';
    const targetedElement = document.getElementById('targeted_panellist');
    const remainingElement = document.getElementById('remaning_panellist');
    const activeElement = document.getElementById('active_panellist');
    const totalElement = document.getElementById('no_of_panelist');
    
    if (targetedElement) targetedElement.innerHTML = loaderHtml;
    if (remainingElement) remainingElement.innerHTML = loaderHtml;
    if (activeElement) activeElement.innerHTML = loaderHtml;
    if (totalElement) totalElement.innerHTML = loaderHtml;

    return Promise.resolve()
      .then(() => SamplesAPI.targetpanelistAPI(requestBody, overrideCountry))
      .then((response) => {
        if (this.targetPanelistRequestId !== currentRequestId) return;
        const { targetedCount, panelistCount, activeCount } = response.data.data;
        if (totalElement) { totalElement.innerHTML = panelistCount.toString(); }
        if (activeElement) { activeElement.innerHTML = activeCount; }
        if (targetedElement) {
          // targetedCount accounts for the isActive toggle because THIS function
          // sends isActive in requestBody above and the server applies it as
          // activeOnly. Both halves are required: when the server read isActive
          // but the client did not send it, activeOnly was undefined and
          // Targeted showed the entire unfiltered population (211196 instead of
          // ~62031 on staging) while Active showed the correct figure.
          // Do not re-decide here — picking activeCount and persisting it as
          // profileCount is what made the sample row record a number that did
          // not match its own contents (B1).
          targetedElement.innerHTML = targetedCount;
          this.setState(() => ({ profileCount: targetedCount }));
        } else {
          console.error("Element with ID 'targeted_panellist' not found.");
        }
        if (remainingElement) {
          const difference = panelistCount - targetedCount;
          remainingElement.innerHTML = difference.toString();
        } else {
          console.error("Element with ID 'remaning_panellist' not found.");
        }
      })
      .catch((error) => {
        if (this.targetPanelistRequestId !== currentRequestId) return;
        const errorHtml = '<span class="text-danger" title="Error fetching count"><i class="fa fa-exclamation-triangle"></i> Error</span>';
        if (targetedElement) targetedElement.innerHTML = errorHtml;
        if (remainingElement) remainingElement.innerHTML = errorHtml;
        if (activeElement) activeElement.innerHTML = errorHtml;
        if (totalElement) totalElement.innerHTML = errorHtml;
        // Non-disruptive: count preview failed, leave the form mounted as-is.
        console.error('targetpanelist count preview failed:', error && error.message);
      });
  };

  handleAddMore = () => {
    const newField = { gender: "", fromAge: null, toAge: null };
    this.setState((prevState) => ({
      dynamicFields: [...prevState.dynamicFields, newField],
    }));
  };

  handleDelete = (index) => {
    if (this.state.dynamicFields.length > 1) {
      this.setState((prevState) => ({
        dynamicFields: prevState.dynamicFields.filter((_, i) => i !== index),
      }), () => this.targetpanelist());
    }
  };
  // add functionality no of pannel list view...  change ---------------------
  totalPanelistRequestId: number = 0;
  Total_no_panelist = async () => {
    this.totalPanelistRequestId = (this.totalPanelistRequestId || 0) + 1;
    const currentRequestId = this.totalPanelistRequestId;
    const loaderHtml = '<span class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></span>';
    const noOfPanelistElement = document.getElementById('no_of_panelist');
    const activePanelistElement = document.getElementById('active_panellist');
    if (noOfPanelistElement) noOfPanelistElement.innerHTML = loaderHtml;
    if (activePanelistElement) activePanelistElement.innerHTML = loaderHtml;

    try {
      const response = await SamplesAPI.Total_no_panelist(this.props.lockedCountry?.value);
      if (response) {
        const { panelistCount, activeCount } = response.data.data;
        // DEFECT-8: this function must NOT write targeted_panellist or
        // remaning_panellist. targetpanelist() owns both, and both functions
        // writing them raced — whichever HTTP response landed last won, so the
        // edit screen showed the STORED profileCount or the RECOMPUTED
        // targetedCount nondeterministically while always persisting the
        // recomputed one. One function owns the tile. They fall back to the
        // static 0 in the markup until targetpanelist()'s response lands.
        if (this.totalPanelistRequestId !== currentRequestId) return;
        if (noOfPanelistElement) noOfPanelistElement.innerHTML = panelistCount.toString();
        if (activePanelistElement) activePanelistElement.innerHTML = activeCount.toString();
      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      if (this.totalPanelistRequestId !== currentRequestId) return;
      const errorHtml = '<span class="text-danger" title="Error fetching count"><i class="fa fa-exclamation-triangle"></i> Error</span>';
      if (noOfPanelistElement) noOfPanelistElement.innerHTML = errorHtml;
      if (activePanelistElement) activePanelistElement.innerHTML = errorHtml;
      console.error("Error fetching total number of panelists:", error);
    }
  }
  // ---------------------------- Targeting profile function ---------------------------------
  Accordion_databview = async () => {
    try {
      const response = await ProfileManagementAPI.getAll();
      if (response && Array.isArray(response)) {
        this.setState({ accordience: response });
      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      console.error("Error fetching profile data:", error);
    }
  }

  // Fetch questions based on the selected profile ID
  Accordion_Question_view = async (id, profileText) => {
    try {
      const response = await ProfileManagementAPI.getAllQuestions(10000, id);
      if (response && Array.isArray(response)) {
        let newResponse = response.map((ele) => { ele.profileName = profileText; return ele; });
        this.setState({ profileQuestion: newResponse });
      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      console.error("Error fetching questions data:", error);
    }
  }
  Accordion_Answers_view = async (id, queText, proText) => {
    try {
      const response = await ProfileManagementAPI.getOneQuestions(id);

      if (response?.options) {
        let newAnswerObj = response.options.map((elem) => { elem.profileId = response.dataValues.profileId; elem.questionName = queText; elem.profileName = proText; return elem; });
        this.setState({ profileAnswers: newAnswerObj });
      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      console.error("Error fetching answers data:", error);
    }
  }

  handleProfileClick = (profileId, profileName) => {

    this.setState({ selectedProfileId: profileId, profileQuestion: [] });
    this.Accordion_Question_view(profileId, profileName);
  }
  handleQuestionClick = (questionId, questionText, profileText) => {


    this.setState({ selectedQuestionId: questionId, profileAnswers: [] });
    this.Accordion_Answers_view(questionId, questionText, profileText);
  }

  //  =================CHECKBOX TARGETED PRPOFILE============
  handleProfileCheckbox = (profileId, isChecked, wholeElem, type) => {
    this.setState(prevState => {
      const disabledCheckboxes = { ...prevState.disabledCheckboxes };
      if (isChecked) {
        disabledCheckboxes[profileId] = true; // Disable related checkboxes for this profile
        let newObj = { "profileName": wholeElem.name, "id": wholeElem.id, type };
        this.addDataInTableFunc(newObj);
      } else {
        delete disabledCheckboxes[profileId]; // Enable checkboxes for this profile
        this.removeItemFromTableFunc(wholeElem.id, type);
      }
      return {
        disabledCheckboxes
      };
    },
    );
  };
  //  =================CHECKBOX TARGETED QUESTION============
  handleQuestionCheckbox = (questionId, isChecked, wholeElem, type) => {
    this.setState(
      (prevState) => {
        // Use a Set to manage the state for checked questions

        if (isChecked) {
          // Add questionId to the checked questions set
          let newObj = { "profileName": wholeElem.profileName, "questionName": wholeElem.text, "id": wholeElem.id, "questionId": wholeElem.id, "profileId": wholeElem.profileId, type };
          this.addDataInTableFunc(newObj);
        } else {
          // Remove questionId from the checked questions set
          this.removeItemFromTableFunc(wholeElem.id, type);
        }
      },
    );
  };

  addDataInTableFunc = (paramElem) => {
    this.setState((prev) => {
      let filteredElems: string[] = [];
      if (prev.selectedTableItemsArray) {
        filteredElems = prev.selectedTableItemsArray.filter(elem => {
          if (paramElem.type === "Profile") {
            return elem.profileId !== paramElem.id;
          }
          else if (paramElem.type === "Question") {
            return elem.questionId !== paramElem.id;
          }
          return true;
        });
      }

      const newState = {
        ...prev,
        selectedTableItemsArray: [...filteredElems, paramElem],
        enableDisableTargetPanelistButton: { "status": false, "text": "Update Targeted Panelists" },
      };

      newState.profileTarget = [];
      newState.questionTarget = [];
      newState.answersTarget = [];
      [...filteredElems, paramElem].forEach((elem) => {
        if (elem.type == "Profile") { newState.profileTarget.push(elem.id) }
        else if (elem.type == "Question") { newState.questionTarget.push(elem.id) }
        else { newState.answersTarget.push(elem.id) }
      })
      return newState;
    });
  }

  removeItemFromTableFunc = (paramElem, elemType) => {
    this.setState((prevState) => {
      let newFilteredArr = prevState.selectedTableItemsArray.filter(elem => elem.id != paramElem);
      if (elemType === "Profile") {
        let disabledCheckboxes = { ...prevState.disabledCheckboxes };
        delete disabledCheckboxes[paramElem];
        let newProfileFilter = prevState.profileTarget.filter(elem => elem != paramElem);
        return { selectedTableItemsArray: newFilteredArr, profileTarget: newProfileFilter, disabledCheckboxes, enableDisableTargetPanelistButton: { "status": false, "text": "Update Targeted Panelists" } };
      }
      else if (elemType === "Question") {
        let newQuestionFilter = prevState.questionTarget.filter(elem => elem != paramElem);
        return { selectedTableItemsArray: newFilteredArr, questionTarget: newQuestionFilter, enableDisableTargetPanelistButton: { "status": false, "text": "Update Targeted Panelists" } };
      }
      else if (elemType === "Answer") {
        let newAnswerFilter = prevState.answersTarget.filter(elem => elem != paramElem);
        return { selectedTableItemsArray: newFilteredArr, answersTarget: newAnswerFilter, enableDisableTargetPanelistButton: { "status": false, "text": "Update Targeted Panelists" } };
      }
    },
      () => {
        if (this.state.selectedTableItemsArray.length == 0) {
          this.updatePayload();
        }
      })
  }

  filterPanelistByProfileTargeting = () => {
    this.setState({ enableDisableTargetPanelistButton: { "status": true, "text": "Updated" } }, () => this.updatePayload());
  }


  handleAnswersCheckbox = (answersIdselected, isChecked, wholeElem, type) => {
    this.setState(
      (prevState) => {
        // Use a Set to manage the state for checked answers

        if (isChecked) {
          // Add answersIdselected to the checked answers set
          let newObj = { "profileName": wholeElem.profileName, "questionName": wholeElem.questionName, "answerName": wholeElem.value, "id": wholeElem.id, "questionId": wholeElem.questionId, "profileId": wholeElem.profileId, type };
          this.addDataInTableFunc(newObj);
        } else {
          // Remove answersIdselected from the checked answers set
          this.removeItemFromTableFunc(wholeElem.id, type);
        }
      });
  };

  handleIpFocusFunc = async (type) => {
    try {
      let payloadData = {
        "type": type,
        "region": this.state.selectedRegionValues,
        "tiers": this.state.selectedTiers,
        "states": this.state.selectedStates,
        "districts": this.state.selectedSegments,
      };
      const response: any = await SamplesAPI.getsegmentwisedetails(payloadData);
      if (response) {
        if (type == "region") {
          const regions = response.data.map((item) => ({ label: item.region, value: item.region, }));
          this.setState({ regions: regions, })
        }

        if (type == "tier") {
          const tiers = response.data.map((item) => ({ label: item.tier, value: item.tier, }));
          this.setState({ tiers: tiers, });
        }

        if (type == "states") {
          const states = response.data.map((item) => ({ label: item.name, value: item.id, }));
          this.setState({ states: states, });
        }

        if (type == "district") {
          const segments = response.data.map((item) => ({ label: item.segment, value: item.segment, }));
          this.setState({ segments: segments, });
        }

        if (type == "cities") {
          const cities = response.data.map((item) => ({ label: item.name, value: item.id, }));
          this.setState({ cities: cities, });
        }

      } else {
        console.error("Invalid response format:", response);
      }
    } catch (error) {
      console.error("Error fetching total number of panelists:", error);
    }
  }

  // Hey! sonarqube, please ignore this code.
  // handleCheckboxIp = (e) => {
  //   const { name, checked } = e.target;
  //   this.setState((prevState) => {
  //     let newObj = { ...prevState.loginType };
  //     if (((name == 'mac' && !newObj.windows) || (name == 'windows' && !newObj.mac)) && (newObj.desktop)) { newObj.desktop = false; }
  //     if (((name == 'tablet_android' && !newObj.tablet_ios) || (name == 'tablet_ios' && !newObj.tablet_android)) && newObj.tablet) { newObj.tablet = false; }
  //     if (((name == 'mobile_ios' && !newObj.mobile_android) || (name == 'mobile_android' && !newObj.mobile_ios)) && newObj.mobile) { newObj.mobile = false; }
  //     if (name == 'desktop') { newObj.windows = checked; newObj.mac = checked; }
  //     if (name == 'tablet') { newObj.tablet_android = checked; newObj.tablet_ios = checked; }
  //     if (name == 'mobile') { newObj.mobile_android = checked; newObj.mobile_ios = checked; }
  //     if ((name == 'windows' || name == 'mac') && checked) { newObj.desktop = true; }
  //     if ((name == 'tablet_android' || name == 'tablet_ios') && checked) { newObj.tablet = true; }
  //     if ((name == 'mobile_android' || name == 'mobile_ios') && checked) { newObj.mobile = true; }
  //     newObj[name] = checked;
  //     return { loginType: newObj };
  //   }, () => { this.updatePayload() });
  // }

  handleCheckboxIp = (e) => {
    const { name, checked } = e.target;
    this.setState((prevState) => {
      const newObj = { ...prevState.loginType };
      const desktopChildren = ['windows', 'mac'];
      const tabletChildren = ['tablet_android', 'tablet_ios'];
      const mobileChildren = ['mobile_android', 'mobile_ios'];
      if (name === 'desktop') {
        desktopChildren.forEach(child => newObj[child] = checked);
      } else if (name === 'tablet') {
        tabletChildren.forEach(child => newObj[child] = checked);
      } else if (name === 'mobile') {
        mobileChildren.forEach(child => newObj[child] = checked);
      }
      if (desktopChildren.includes(name)) {
        newObj.desktop = checked || newObj[desktopChildren.find(child => child !== name)];
      }
      if (tabletChildren.includes(name)) {
        newObj.tablet = checked || newObj[tabletChildren.find(child => child !== name)];
      }
      if (mobileChildren.includes(name)) {
        newObj.mobile = checked || newObj[mobileChildren.find(child => child !== name)];
      }
      newObj[name] = checked;
      return { loginType: newObj };
    }, this.updatePayload);
  };



  render() {
    const { disabledCheckboxes, selectedProfileId, profileQuestion, profileAnswers } = this.state;
    const isQueChecked = (answer) => { return this.state.questionTarget?.some((number) => number == answer.questionId) }
    const isAnsChecked = (answer) => { return this.state.answersTarget?.some((number) => number == answer.id) }
    const renderProfileAnswers = (profileAnswers, isAnsChecked, isQueChecked, handleAnswersCheckbox) => {
      return profileAnswers.map((answer) => (
        <Card key={answer.id} className="mb-2">
          <Accordion.Toggle
            as={Card.Header}
            eventKey={`answer-${answer.id}`}
            className="d-flex align-items-center justify-content-left"
          >
            <input
              id="answerscheckbox"
              className="mx-3"
              type="checkbox"
              checked={
                isAnsChecked(answer) ||
                disabledCheckboxes[answer.profileId] ||
                isQueChecked(answer)
              }
              onChange={(e) =>
                handleAnswersCheckbox(answer.id, e.target.checked, answer, "Answer")
              }
              disabled={
                disabledCheckboxes[answer.profileId] || isQueChecked(answer) || false
              }
            />
            <span className="d-flex align-items-left justify-content-left">
              {answer.value}
            </span>
          </Accordion.Toggle>
        </Card>
      ));
    }

    return (
      <Modal
        centered
        size="xl"
        backdrop="static"
        onHide={this.props.onClose}
        show={this.props.show}
        style={{ zIndex: 1201 }}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className='d-flex justify-content-between w-100'>
              {/* Left Side */}
              <div className='d-flex align-items-center'>
                <h3 >Sample</h3>
              </div>

              {/* Right Side */}
              <div className='d-flex align-items-center mx-3'>
                <div className='mx-3'>
                  <h6 htmlFor="no_of_panelist" title="All non-deleted panelists in the selected country that have a completed basic profile (the same population as the country Panelists dashboard). Ignores every filter on this form, including the registration window and the Active toggle. Remaining = this minus Targeted.">No. Of Panelist</h6>
                  <h6 id='no_of_panelist' className='text-success'>0</h6>
                </div>
                <div className='mx-3'>
                  <h6 htmlFor="targeted_panellist" title="Profile-complete panelists matching every selected criterion: registration window, demographics, geography, devices, and Active (when ticked). This is the set a saved sample contains.">Targeted Panelist Count</h6>
                  <h6 id='targeted_panellist' className='text-info'>0</h6>
                </div>
                <div className='mx-3'>
                  <h6 htmlFor="remaining_panellist" title="No. Of Panelist minus Targeted Panelist Count.">Remaining Panelist</h6>
                  <h6 id='remaning_panellist' className='remaning' >0</h6>
                </div>
                <div className='mx-3'>
                  <h6 htmlFor="active_panellist" title="Profile-complete panelists matching the selected criteria who are active (activeStatus 0) and have a recorded last activity. Informational only; a saved sample contains the Targeted set.">Active Panelist</h6>
                  <h6 id='active_panellist' className='text-success' >0</h6>
                </div>
              </div>
            </div>
          </Modal.Title>
        </Modal.Header>

        <Modal.Body style={{ maxHeight: '78vh', overflow: 'auto' }}>
          <Show when={this.state.status === PageStatus.Loading}>
            <div className="d-flex justify-content-center w-100 p-5">
              <Spinner animation="border" variant="primary" />
            </div>
          </Show>

          <Alert variant="danger" show={this.state.status === PageStatus.Error}>
            {this.state.error}
          </Alert>

          <Show when={this.state.status === PageStatus.Loaded}>
            <form onSubmit={(e) => { e.preventDefault(); this.onSubmit(); }}>

              <div className="row mt-2">
                <div className="col-md-6">
                  <label htmlFor="name">Name*</label>
                  <input
                    className="form-control"
                    name="name"
                    onChange={(e) => this.setState({ name: e.target.value })}
                    value={this.state.name}
                    placeholder="Enter here"
                    required
                  />
                </div>

                <div className="col-md-1 mt-5 ml-3">
                  <input
                    type="checkbox"
                    id="useUniqueLinks"
                    name="useUniqueLinks"
                    className="custom-control-input"
                    checked={this.state.isActive}
                    onChange={() => this.setState((prev) => ({ isActive: !prev.isActive }), () => { this.targetpanelist(); })}
                  />
                  <label className="custom-control-label" htmlFor="useUniqueLinks">Active*</label>
                </div>

                <div className="card col-md-4 mt-3 ml-3 p-1" style={{ backgroundColor: "#e8e8e8" }}>
                  <div className='d-flex justify-content-between'>
                    <div>
                      <label className="form-check-label" htmlFor="label1">Select Device</label>
                      <div>
                        <div className="ml-4">
                          <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="desktop" id="inlineRadio1" checked={this.state.loginType.desktop} />
                          <label className="custom-control-label" htmlFor="inlineRadio1">Desktop</label>
                        </div>
                        <div className="ml-4">
                          <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="tablet" id="inlineRadio2" checked={this.state.loginType.tablet} />
                          <label className="custom-control-label" htmlFor="inlineRadio2">Tablet</label>
                        </div>
                        <div className="ml-4">
                          <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="mobile" id="inlineRadio3" checked={this.state.loginType.mobile} />
                          <label className="custom-control-label" htmlFor="inlineRadio3">Mobile</label>
                        </div>
                      </div>
                    </div>
                    <div>
                      <label className="form-check-label" htmlFor="label2">Select OS</label>
                      <div>
                        <div className='d-flex justify-content-center'>
                          <div className="mr-2">
                            <div>
                              <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="windows" id="inlineRadio4" checked={this.state.loginType.windows} />
                              <label className="custom-control-label" htmlFor="inlineRadio4">Windows</label>
                            </div>
                            <div>
                              <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="tablet_android" id="inlineRadio6" checked={this.state.loginType.tablet_android} />
                              <label className="custom-control-label" htmlFor="inlineRadio6">Android</label>
                            </div>
                            <div>
                              <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="mobile_android" id="inlineRadio8" checked={this.state.loginType.mobile_android} />
                              <label className="custom-control-label" htmlFor="inlineRadio8">Android</label>
                            </div>
                          </div>
                          <div className="mx-4">
                            <div>
                              <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="mac" id="inlineRadio5" checked={this.state.loginType.mac} />
                              <label className="custom-control-label" htmlFor="inlineRadio5">Mac</label>
                            </div>
                            <div>
                              <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="tablet_ios" id="inlineRadio7" checked={this.state.loginType.tablet_ios} />
                              <label className="custom-control-label" htmlFor="inlineRadio7">iOS</label>
                            </div>
                            <div>
                              <input className="custom-control-input" onChange={(e) => { this.handleCheckboxIp(e) }} type="checkbox" name="mobile_ios" id="inlineRadio9" checked={this.state.loginType.mobile_ios} />
                              <label className="custom-control-label" htmlFor="inlineRadio9">iOS</label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row ">
                <div className="col">
                  <label htmlFor="description">Description</label>
                  <input
                    className="form-control"
                    type="textbox"
                    name="description"
                    onChange={(e) => this.setState({ description: e.target.value })}
                    value={this.state.description}
                    placeholder="Enter here"

                  />
                </div>
              </div>

              {this.state.dynamicFields.map((field, index) => (
                <div key={"dynamicFields" + index} className="jumbotron bg-white p-3 border shadow-sm mt-4">
                  <div className="row">
                    <div className="col">
                      <label htmlFor='gender'>Gender <small className="text-muted">(select one or more)</small></label>
                      <Select
                        name='state'
                        id='state'
                        onChange={(e) => this.handleDynamicFieldChange(e, index, 'gender')}
                        value={field.gender}
                        isMulti
                        required
                        placeholder="Select one or more..."
                        options={this.state.genderOptions}
                        menuPortalTarget={document.body}
                        styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="fromAge">Min Age</label>
                      <input
                        className="form-control"
                        id="fromAge"
                        type="number"
                        name="fromAge"
                        value={field.fromAge}
                        onBlur={(e) => this.handleDynamicFieldChange(parseInt(e.target.value, 10), index, 'fromAge')}
                        onChange={(e) => this.handleAgeFilterValue(parseInt(e.target.value, 10), index, 'fromAge')}
                        placeholder="Enter Min Age"
                      />
                    </div>
                    <div className="col">
                      <label htmlFor="fromAge">Max Age</label>
                      <input
                        className="form-control"
                        id="toAge"
                        type="number"
                        name="toAge"
                        value={field.toAge}
                        onBlur={(e) => this.handleDynamicFieldChange(parseInt(e.target.value, 10), index, 'toAge')}
                        onChange={(e) => this.handleAgeFilterValue(parseInt(e.target.value, 10), index, 'toAge')}
                        placeholder="Enter Max Age"
                      />
                    </div>
                  </div>
                  {/* Delete is always visible for consistency. The last remaining
                      row can't be removed (a sample needs at least one gender/age
                      row), so it's shown disabled rather than hidden. */}
                  <div className="col mt-4">
                    <button
                      type="button"
                      className="btn btn-danger"
                      onClick={() => this.handleDelete(index)}
                      disabled={this.state.dynamicFields.length <= 1}
                      title={this.state.dynamicFields.length <= 1 ? 'At least one row is required' : 'Remove this row'}
                    >
                      Delete
                    </button>
                  </div>
                </div>
              ))}

              <button
                type="button"
                className="btn-sm btn-primary mt-3"
                onClick={() => this.handleAddMore()}
              >
                Add More
              </button>

              <div className="row mt-2">
                <div className="col">
                  <label htmlFor="fromRegistrationDate">Registration Start Date</label>
                  <input
                    type="date"
                    className="form-control"
                    id="fromRegistrationDate"
                    name="fromRegistrationDate"
                    max={this.state.maxFromRegistrationDate}
                    onChange={(e) => { this.handleRegistrationDateChange(e, "from") }}
                    onBlur={() => { this.targetPanelistOnRgistrationDate() }}
                    value={this.state.fromRegistrationDate}
                    placeholder="Enter here"

                  />
                </div>
                <div className="col">
                  <label htmlFor="toRegistrationDate">Registration End Date</label>
                  <input
                    type="date"
                    className="form-control"
                    id="toRegistrationDate"
                    name="toRegistrationDate"
                    min={this.state.minToRegistrationDate}
                    onChange={(e) => { this.handleRegistrationDateChange(e, "to") }}
                    onBlur={() => { this.targetPanelistOnRgistrationDate() }}
                    value={this.state.toRegistrationDate}
                    placeholder="Enter here"

                  />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col">
                  <label htmlFor="text">Regions</label>
                  <Select
                    name='state'
                    id='state'
                    onFocus={() => { this.handleIpFocusFunc("region") }}
                    onChange={this.handleRegionChange}
                    value={this.state.selectedRegionsOption}
                    isMulti
                    options={this.state.regions}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col">
                  <label htmlFor="text">Tiers</label>
                  <Select
                    name='tiers'
                    id='tiers'
                    onFocus={() => { this.handleIpFocusFunc("tier") }}
                    onChange={this.handleTierChange}
                    value={this.state.selectedTiersOption}
                    isMulti
                    options={this.state.tiers}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>
              <div className="row mt-2">
                <div className="col">
                  <label htmlFor="text">States</label>
                  <Select
                    name='state'
                    id='state'
                    onFocus={() => { this.handleIpFocusFunc("states") }}
                    onChange={this.handleStateChange}
                    value={this.state.selectedStatesOption}
                    isMulti
                    options={this.state.states}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>

              <div className="row mt-2">
                <div className="col">
                  <label htmlFor="text">District</label>
                  <Select
                    name='state'
                    id='state'
                    onFocus={() => { this.handleIpFocusFunc("district") }}
                    onChange={this.handleSegmentChange}
                    value={this.state.selectedSegmentsOption}
                    isMulti
                    options={this.state.segments}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>


              <div className="row mt-2">
                <div className="col">
                  <label htmlFor="text">Cities</label>
                  <Select
                    name='cities'
                    id='cities'
                    onFocus={() => { this.handleIpFocusFunc("cities") }}
                    onChange={this.handleCityChange}
                    value={this.state.selectedCitiesOption}
                    isMulti
                    options={this.state.cities}
                    isLoading={this.state.cities.length === 0}
                    menuPortalTarget={document.body}
                    styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                  />
                </div>
              </div>

              <Show when={this.state.selectedTableItemsArray.length > 0}>
                <div className="row mt-3">
                  <div className="col">
                    <div className="d-flex justify-content-between">
                      <h4>Selected Items:</h4>
                      <Button
                        onClick={() => this.filterPanelistByProfileTargeting()}
                        variant="primary"
                        size="sm"
                        className="mx-1 mb-2"
                        disabled={this.state.enableDisableTargetPanelistButton.status}
                      >
                        {this.state.enableDisableTargetPanelistButton.text}
                      </Button>
                    </div>
                    <Table responsive size="sm" bordered>
                      <thead>
                        <tr>
                          <th>S.No</th>
                          <th>Profile</th>
                          <th>Question</th>
                          <th>Answer</th>
                          <th>Action</th>
                        </tr>
                      </thead>

                      <tbody>
                        {
                          this.state.selectedTableItemsArray.map((info, index) => (
                            <tr key={info.id}>
                              <td>{index + 1}</td>
                              <td>{info.profileName ?? "-"}</td>
                              <td>{info.questionName ?? "-"}</td>
                              <td>{info.answerName ?? "-"}</td>
                              <td>
                                {/* <Confirmation onAction={() => this.removeItemFromTableFunc(info.id, info.type)} body="Do you want to delete item ?"> */}
                                <Button
                                  variant="danger"
                                  size="sm"
                                  className="mx-1"
                                  onClick={() => this.removeItemFromTableFunc(info.id, info.type)}
                                >
                                  Delete
                                </Button>
                                {/* </Confirmation> */}
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Show>

              {/* Add accordience */}
              <div className="row mt-2">
                <div className="col">
                  <Accordion>
                    <Card>
                      <Accordion.Toggle as={Button} variant="link" eventKey="0" className="toggle-left float-left">
                        <div className='d-flex align-items-center w-100'>
                          <i className="fa fa-chevron-down mr-2" />
                          <span>Additional Target Profile</span>
                        </div>
                      </Accordion.Toggle>
                      <Accordion.Collapse eventKey="0">
                        <Card.Body>
                          <Accordion>
                            {this.state.accordience.map((item) => (
                              <Card key={item.id} className="mb-2">
                                <Accordion.Toggle
                                  as={Button}
                                  variant="link"
                                  eventKey={`profile-${item.id}`}
                                  className="toggle-left d-flex align-items-center w-100"
                                  onClick={() => this.handleProfileClick(item.id, item.name)}
                                >
                                  <i className="fa fa-chevron-down mr-2" />
                                  <input
                                    className='mx-4'
                                    type="checkbox"
                                    // checked={this.state.profileTarget ? this.state.profileTarget.includes(item.id) : false}
                                    checked={this.state.profileTarget ? this.state.profileTarget.some((number) => number == item.id) : ""}
                                    onChange={(e) => this.handleProfileCheckbox(item.id, e.target.checked, item, "Profile")}
                                    onClick={(e) => e.stopPropagation()}
                                  />
                                  <span>{item.name}</span>
                                </Accordion.Toggle>
                                <Accordion.Collapse eventKey={`profile-${item.id}`}>
                                  <Card.Body>
                                    {selectedProfileId === item.id && profileQuestion.length > 0 && (
                                      <Accordion>
                                        {profileQuestion.map((question) => (
                                          <Card key={question.id} className="mb-2">
                                            <Accordion.Toggle
                                              as={Button}
                                              variant="link"
                                              eventKey={`question-${question.id}`}
                                              className="toggle-left d-flex align-items-center w-100"

                                              onClick={() => this.handleQuestionClick(question.id, question.text, question.profileName)}
                                            >
                                              <i className="fa fa-chevron-down mr-2" />
                                              <input
                                                id="questioncheckbox"
                                                className='mx-3'
                                                type="checkbox"
                                                checked={disabledCheckboxes[item.id] || (this.state.questionTarget ? this.state.questionTarget.some((number) => number == question.id) : false)}
                                                onClick={(e) => e.stopPropagation()}
                                                onChange={(e) => this.handleQuestionCheckbox(question.id, e.target.checked, question, 'Question')}
                                                disabled={disabledCheckboxes[item.id] || false} // Disable based on state
                                              />

                                              <span className='text-left'>{question.text}</span>
                                            </Accordion.Toggle>
                                            <Accordion.Collapse eventKey={`question-${question.id}`}>
                                              <Card.Body>
                                                {this.state.selectedQuestionId === question.id && profileAnswers.length > 0 && (
                                                  <Accordion>
                                                    {renderProfileAnswers(
                                                      profileAnswers,
                                                      isAnsChecked,
                                                      isQueChecked,
                                                      this.handleAnswersCheckbox
                                                    )}
                                                  </Accordion>
                                                )}
                                              </Card.Body>
                                            </Accordion.Collapse>
                                          </Card>
                                        ))}
                                      </Accordion>
                                    )}
                                  </Card.Body>
                                </Accordion.Collapse>
                              </Card>
                            ))}
                          </Accordion>
                        </Card.Body>
                      </Accordion.Collapse>
                    </Card>
                  </Accordion>
                </div>
              </div>
              {/* =============== */}


              <Alert variant="danger" show={!!this.state.error} className="mt-2">
                {this.state.error}
              </Alert>

              <div className="d-flex align-items-center mt-2">
                <button
                  type="submit"
                  disabled={!this.state.name}
                  className="btn btn-primary mr-3"
                >
                  Submit
                </button>

                <button
                  type="button"
                  disabled={false}
                  onClick={() => this.reset()}
                  className="btn btn-light mr-3"
                >
                  Reset
                </button>

                <Show when={this.state.status === PageStatus.Submitting}>
                  <Spinner animation="border" variant="primary" />
                </Show>
              </div>
            </form>
          </Show>
        </Modal.Body>
      </Modal >
    );
  }
}

const dataFormRedux = reduxForm<FormValue, any>({
  form: 'dataForm',
})(Form);


const dataFormWithRouter = withRouter(dataFormRedux);

export { dataFormWithRouter as Form };
